import React from 'react'
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import CLabel from '../../../../../Common/CLabel';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { ScrollablePane, ScrollbarVisibility } from '@fluentui/react';

function getDataserieColor(gapAnalyzeElementId, listElements) {
    let element = listElements.find(x => x.id === gapAnalyzeElementId);
    return element !== undefined ? element.htmlColor : ""
}

function GapDataseriesBox(props) {
    const { t } = useTranslation();
   
    const {
        inputParam_ElementList = null,
        inputParam_GapRevisionDataserieList = null,
        inputParam_HigthLigthDataserieList = null,
    } = props;

    return (
        <>
            <Card className="h-100">
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <b>{t('data-lang-boxname-dataserielist')}</b>
                    </Card.Title>
                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar d-flex float-end'>
                    </div>
                </Card.Footer>
                <Card.Body className="card-dataserielist h-100 px-2 py-0">
                    <div className="card-dataserielist-body">
                        {
                            inputParam_ElementList && inputParam_GapRevisionDataserieList && 
                            <Row className='py-2'>
                                <Col className='px-2'>
                                    <ScrollablePane
                                        style={{ minHeight: "242px", maxHeight: "100%", height: "100%"}}
                                        styles={{
                                            root: { position: "relative" },
                                            contentContainer:{overflowX: "hidden"}
                                        }}
                                        scrollbarVisibility={ScrollbarVisibility.auto}
                                        scrollContainerFocus={true}
                                    >
                                        {
                                            inputParam_GapRevisionDataserieList.length > 0 && inputParam_GapRevisionDataserieList.map((dataserie, index) => (
                                                <div data-id={dataserie.id} key={index} className={`mb-1 border-top border-bottom rounded-start ${ inputParam_HigthLigthDataserieList === null ? 'nullJojo' : inputParam_HigthLigthDataserieList.filter(x => x === dataserie.id).length > 0 ? 'onJojo' : 'offJojo' }`} style={{ fontSize: "13px", borderLeft: `10px solid ${ getDataserieColor(dataserie.gapAnalyzeElementId, inputParam_ElementList) }` }}>
                                                    <Row className='p-1'>
                                                        <Col xl={7} className='border-end'>
                                                            <CLabel
                                                                className='pb-0 mb-0'
                                                                labelValue={dataserie.name}
                                                            />
                                                            <div className='pt-0 mt-0' style={{fontSize: "11px"}}>({`${t(dataserie.um)}`})</div>
                                                        </Col>
                                                        <Col xl={5} className='border-end pe-2'>
                                                            <Row>
                                                                <Col>
                                                                    <CLabel labelText={t('data-lang-lbl-measurementperiodshort')} labelValue={t(dataserie.meassurePeriod)} />
                                                                </Col>
                                                                <Col>
                                                                    <Row>
                                                                        <Col className='p-0 m-0'><b>{t('data-lang-lbl-causes')}: </b></Col>
                                                                        <Col className='col-auto me-auto ps-0 ms-0'>{dataserie.nCauses}</Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col className='p-0 m-0'><b>{t('data-lang-lbl-actions')}: </b></Col>
                                                                        <Col className='col-auto me-auto ps-0 ms-0'>{dataserie.nActions}</Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))
                                        }
                                        <NoDataLayer display={inputParam_GapRevisionDataserieList.length === 0}/>
                                    </ScrollablePane>
                                </Col>
                            </Row>
                        }
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}

GapDataseriesBox.propTypes = {
    inputParam_ElementList: PropTypes.array,
    inputParam_GapRevisionDataserieList: PropTypes.array,
    inputParam_HigthLigthDataserieList: PropTypes.array,
};

export default GapDataseriesBox;

